<template>
    <div class="fashion-filters-wrapper" :class="{'accordion-open': accordion}">
        <div class="wrapper">
            <span
                    class="d-inline-block d-lg-none top-close-filters"
                    @click="accordionToggle()"
            >
                <svg width="24" height="24">
                    <g>
                        <line x1="12" y1="0" x2="12" y2="24" stroke="#fff"/>
                        <line x1="0" y1="12" x2="24" y2="12" stroke="#fff"/>
                    </g>
                </svg>
            </span>

            <div class="search d-block d-lg-none">
                <form @submit="searchSubmit()">
                    <div class="search-wrapper">
                        <input id="search" v-model="searchModelData" placeholder="Type your search"/>
                    </div>
                </form>
            </div>

            <FashionFilter
                    v-if="filters[index]"
                    v-for="(item, index) in filters"
                    :key=index
                    :name=index
                    :title=index
                    :status=filtersStatus[index]
                    :terms=filters[index].terms
                    :setFilter=setFilter
                    :activeFilters=activeFilters
                    :filterLabels=filterLabels
                    :currentActiveFilter=currentActiveFilter
                    :setCurrentActiveFilter=setCurrentActiveFilter
            />
        </div>
    </div>
</template>

<script>
import FashionFilter from './FashionFilter'

export default {
  name: 'FashionFiltersWrapper',
  props: [
    'filters',
    'callback',
    'keys',
    'filtersStatus',
    'activeFilters',
    'filterLabels',
    'accordion',
    'accordionFn',
    'searchModel',
    'searchFn',
    'searchTerm'
  ],
  components: {
    FashionFilter
  },
  data () {
    return {
      searchModelData: '',
      currentActiveFilter: null
    }
  },
  methods: {
    setFilter (filter, term, uri) {
      this.callback(filter, term, uri)
      this.accordionFn(false)
    },
    searchSubmit (event) {
      if (event) {
        event.preventDefault()
      }
      let vm = this
      vm.searchFn(event, vm.searchModelData)
      vm.accordionFn()
    },
    accordionToggle () {
      let vm = this
      vm.accordionFn()
    },
    setCurrentActiveFilter (name) {
      let vm = this
      vm.currentActiveFilter = name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FashionFiltersWrapper.vue